import React from 'react';
import { TAB_OPTIONS } from '../Model/AllowedModules';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */

const SetUpPrivilegesApp = ({ web, mobile, selectedPermissions }) => {
    const { t } = useTranslation();
    const [selectedInnerView, setSelectedInnerView] = useState(TAB_OPTIONS.MOBILE);

    // Handles tab change
    const handleStepSelectedInnerView = (tab) => {
        setSelectedInnerView(tab);
    };

    const totalSelected =
        selectedPermissions?.filter((permission) => {
            const permissionData =
                web?.find((item) => item.id === permission.id) || mobile?.find((item) => item.id === permission.id);

            return permissionData && !permissionData.name.endsWith('_MENU');
        }).length || 0;

    return { handleStepSelectedInnerView, selectedInnerView, t, totalSelected };
};

export default SetUpPrivilegesApp;
